import { useModuleBEM, usePackagesStyles } from "@b2bportal/core-themes";
import { CorePackagesComponent } from "@b2bportal/core-types";
import { DeparturePage } from "@tenant/flights";
import defaultStyles from "./PackageFlightDeparturePage.module.scss";
import type { PackageFlightDeparturePageProps } from "./types";

const COMPONENT_KEY = CorePackagesComponent.PackageFlightDeparturePage;

export const PackageFlightDeparturePage = (
  props: PackageFlightDeparturePageProps
) => {
  const styles = usePackagesStyles(COMPONENT_KEY, defaultStyles);
  const [block] = useModuleBEM(styles, COMPONENT_KEY);
  return <DeparturePage className={block} {...props} />;
};
